export default __webpack_public_path__ + "static/media/education.d5cc42f0.svg";